import { render, staticRenderFns } from "./PatentEcharts.vue?vue&type=template&id=58a3e0a6"
import script from "./PatentEcharts.vue?vue&type=script&lang=js"
export * from "./PatentEcharts.vue?vue&type=script&lang=js"
import style0 from "./PatentEcharts.vue?vue&type=style&index=0&id=58a3e0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports